"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useSearchBox } from "react-instantsearch";
interface SearchBoxConnectorProps {
  query: string;
}

/**
 * Invisible component that syncs external query state
 * with InstantSearch's internal search box state.
 * This allows the SearchInput (outside of InstantSearch's built-in components)
 * to drive search queries.
 */
export function SearchBoxConnector(t0) {
  const $ = _c(4);
  const {
    query
  } = t0;
  const {
    refine
  } = useSearchBox();
  let t1;
  let t2;
  if ($[0] !== query || $[1] !== refine) {
    t1 = () => {
      refine(query);
    };
    t2 = [query, refine];
    $[0] = query;
    $[1] = refine;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}